import clsx from 'clsx';

import { AnalysisMarkdown } from './AnalysisMarkdown';

interface TwoColumnProseProps {
  text?: string;
  /**
   * `alt` is the default, for prose that sits on the page. `strong` is for prose inside a
   * tinted panel, where the design lifts it to full-strength foreground.
   */
  tone?: 'alt' | 'strong';
}

/**
 * A long passage set in two columns from `lg` up.
 *
 * Every one of these runs past a comfortable measure at full width, which costs a reader
 * the line. Below `lg` the columns would be too narrow to help, so it stays single.
 */
export const TwoColumnProse = ({ text, tone = 'alt' }: TwoColumnProseProps) => (
  <AnalysisMarkdown
    text={text}
    className={clsx(
      'text-pretty text-body-md lg:columns-2 lg:gap-8',
      tone === 'strong' ? 'text-foreground' : 'text-foreground-alt',
    )}
  />
);
